import React, { useState } from "react";
import { Plus, Minus, Mail } from "lucide-react";
import PageShell from "@/components/PageShell";

const FAQS = [
  {
    q: "What is GigAfloat?",
    a: "GigAfloat is a platform being built to support gig workers with financial flexibility when unexpected expenses arise.",
  },
  {
    q: "Is GigAfloat available today?",
    a: "GigAfloat is currently collecting feedback and building future products. Join the waitlist to stay informed.",
  },
  {
    q: "Which gig platforms are supported?",
    a: "We're researching support for major gig platforms including rideshare, delivery, and shopping services.",
  },
  {
    q: "How much does GigAfloat cost?",
    a: "Pricing and membership options are still being evaluated based on user feedback.",
  },
  {
    q: "How do I stay updated?",
    a: "Join the waitlist and follow future announcements from GigAfloat.",
  },
  {
    q: "How can I contact support?",
    a: "Email gigafloatapp@gmail.com and we'll get back to you as soon as possible.",
  },
];

const Item = ({ q, a, open, onClick, testid }) => (
  <div className="rounded-2xl border border-white/8 bg-white/[0.02] overflow-hidden" data-testid={testid}>
    <button
      type="button"
      onClick={onClick}
      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-white/[0.02] transition-colors"
    >
      <span className="font-display font-extrabold tracking-tight text-base sm:text-lg">{q}</span>
      <span className="w-7 h-7 shrink-0 rounded-full border border-white/15 grid place-items-center text-white/70">
        {open ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
      </span>
    </button>
    {open && (
      <div className="px-5 pb-5 text-white/65 leading-relaxed text-[15px]">{a}</div>
    )}
  </div>
);

const Help = () => {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <PageShell
      eyebrow="// Help center"
      title="Frequently Asked Questions"
      subtitle="Quick answers to common questions about GigAfloat. Still stuck? Reach out and we'll help."
      testid="help-page"
    >
      <div className="space-y-3 mb-12">
        {FAQS.map((f, i) => (
          <Item
            key={f.q}
            q={f.q}
            a={f.a}
            open={openIdx === i}
            onClick={() => setOpenIdx(openIdx === i ? -1 : i)}
            testid={`help-faq-${i}`}
          />
        ))}
      </div>

      <div className="rounded-2xl border border-[#00FF88]/25 bg-[#00FF88]/5 p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <div className="font-mono-c text-[10px] uppercase tracking-[0.2em] text-[#00FF88]">// Need a hand?</div>
          <div className="font-display font-extrabold text-lg mt-1">We usually reply within a day.</div>
        </div>
        <a
          href="mailto:gigafloatapp@gmail.com?subject=Help%20request"
          className="inline-flex items-center gap-2 bg-[#00FF88] text-black font-bold text-sm px-5 py-2.5 rounded-full btn-glow"
          data-testid="help-email-cta"
        >
          <Mail className="w-4 h-4" />
          Email support
        </a>
      </div>
    </PageShell>
  );
};

export default Help;
